import type { DatasetZoomProps } from "./dataset-zoom.type";

import DatasetZoomButton from "./dataset-zoom-button";
import DatasetZoomModal from "./dataset-zoom-modal";
import DatasetZoomModalActions from "./dataset-zoom-modal-actions";
import DatasetZoomModalHeader from "./dataset-zoom-modal-header";
import { useDatasetZoom } from "./dataset-zoom.hook";

const DatasetZoom = ({
  datasetType,
  template,
  dataset,
  loading,
  disabled,
  children,
}: DatasetZoomProps) => {
  const { isOpen, openModal, closeModal } = useDatasetZoom();

  return (
    <div className="dataset-zoom">
      <DatasetZoomButton
        datasetType={datasetType}
        loading={loading}
        onClick={openModal}
      />
      <DatasetZoomModal
        datasetType={datasetType}
        loading={loading}
        title={
          <DatasetZoomModalHeader
            title={template.name}
            actions={
              <DatasetZoomModalActions
                datasetType={datasetType}
                dataset={dataset}
                loading={loading}
                disabled={disabled}
                onCancelClick={closeModal}
                onSaveClick={closeModal}
                onCloseClick={closeModal}
              />
            }
          />
        }
        open={isOpen}
        onCancel={closeModal}
      >
        {children}
      </DatasetZoomModal>
    </div>
  );
};

export default DatasetZoom;
